module.exports = __webpack_public_path__ + "img/browserGrey.4863319d.svg";